import React from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import Section from '../shared/Section';


const MentionsLegales = (): React.JSX.Element => {

    const { t } = useTranslation();

    const navigate = useNavigate();

    return <>
        <Section className="legal-wrapper">
            <Row>
                <Col xs={12} className="text-center">

                    <h2 dangerouslySetInnerHTML={{ __html: t('Pages.Legal.Title')! }}></h2>

                </Col>
            </Row>

            <Row>
                <Col xs={0} sm={0} md={1} lg={2}></Col>
                <Col xs={12} sm={12} md={10} lg={8} className="text-left">
                    <p dangerouslySetInnerHTML={{ __html: t('Pages.Legal.MentionText')! }}>
                    </p>
                    <p dangerouslySetInnerHTML={{ __html: t('Pages.Legal.Contact')! }}>
                    </p>
                    <p>{t('Pages.Legal.CommunicationExecutor')! }</p>
                    <p>
                        {t('Pages.Legal.Host')}
                    </p>
                    <p>
                        {t('Pages.Legal.OVHHeadOffice')}
                    </p>
                    <p dangerouslySetInnerHTML={{ __html: t('Pages.Legal.OVHNumber')! }}>

                    </p>
                    <p dangerouslySetInnerHTML={{ __html: t('Pages.Legal.OVHWebsite')! }}>

                    </p>
                </Col>
                <Col xs={0} sm={0} md={1} lg={2}></Col>
            </Row>
            <Row>
                <Col xs={0} sm={0} md={1} lg={2}></Col>

                <Col xs={12} sm={12} md={12} lg={12} className="text-center">
                    <h4 dangerouslySetInnerHTML={{ __html: t('Pages.Legal.ContactTitle')! }}></h4>
                </Col>
            </Row>
            <Row>
                <Col xs={0} sm={0} md={1} lg={2}></Col>
                <Col xs={12} sm={12} md={10} lg={8} className="text-left">
                    <p>
                        {t('Pages.Legal.SubTitleContact1')}
                    </p>
                    <p>
                        {t('Pages.Legal.SubTitleContact2')}
                    </p>
                    <p>
                        {t('Pages.Legal.SubTitleContact3')}
                    </p>
                </Col>
                <Col xs={0} sm={0} md={1} lg={2}></Col>

            </Row>

            <Row>
                <Col xs={0} sm={0} md={1} lg={2}></Col>
                <Col xs={12} sm={12} md={12} lg={8} className="text-center">
                    <h4 dangerouslySetInnerHTML={{ __html: t('Pages.Legal.ConditionTitle')! }}></h4>
                </Col>
            </Row>

            <Row>
                <Col xs={0} sm={0} md={1} lg={2}></Col>
                <Col xs={12} sm={12} md={10} lg={8} className="text-left">
                    <h6 dangerouslySetInnerHTML={{ __html: t('Pages.Legal.SubTitleCondition1')! }}></h6>
                </Col>
            </Row>
            <Row>
                <Col xs={0} sm={0} md={1} lg={2}></Col>
                <Col xs={12} sm={12} md={10} lg={8} className="text-left">
                    <p>{t('Pages.Legal.SubTitleCondition2')}</p>
                    <p> {t('Pages.Legal.SubTitleCondition3')}</p>
                    <p> {t('Pages.Legal.SubTitleCondition4')}</p>
                </Col>
            </Row>
            <Row>
                <Col xs={0} sm={0} md={1} lg={2}></Col>
                <Col xs={12} sm={12} md={10} lg={8} className="text-left">
                    <h6 dangerouslySetInnerHTML={{ __html: t('Pages.Legal.SubTitleCondition5')! }}></h6>
                </Col>
            </Row>
            <Row>
                <Col xs={0} sm={0} md={1} lg={2}></Col>
                <Col xs={12} sm={12} md={10} lg={8} className="text-left">
                    <p>{t('Pages.Legal.SubTitleCondition6')}</p>
                </Col>
            </Row>

            <Row>
                <Col xs={0} sm={0} md={1} lg={2}></Col>
                <Col xs={12} md={10} lg={8}>
                    <p>{t('Pages.Legal.SubTitleCondition7')}</p>
                    <p>{t('Pages.Legal.SubTitleCondition8')}</p>
                    <p>{t('Pages.Legal.SubTitleCondition9')}</p>
                    <p>{t('Pages.Legal.SubTitleCondition10')}</p>
                    <p>{t('Pages.Legal.SubTitleCondition11')}</p>
                </Col>
            </Row>

            <Row>
                <Col xs={0} sm={0} md={1} lg={2}></Col>
                <Col xs={12} md={10} lg={8} >
                    <p>{t('Pages.Legal.SubTitleCondition12')}</p>
                    <p>{t('Pages.Legal.SubTitleCondition13')}</p>
                    <p>{t('Pages.Legal.SubTitleCondition14')}</p>
                    <p>{t('Pages.Legal.SubTitleCondition15')}</p>
                    <p>{t('Pages.Legal.SubTitleCondition16')}</p>
                </Col>
            <p style={{ marginBottom: '25px' }}></p>
            </Row>
        </Section>

    </>
};

export default MentionsLegales;